import { loadLanguageAsync } from '@/i18n'

export default {
  methods: {
    onChangeLocale (locale) {
      this.$i18n.locale = locale.value
      this.$store.commit('admin/system/setLanguage', locale)

      loadLanguageAsync({
        funcID: this.$route.meta.funcID,
        curLanguage: locale.value
      })
    }
  }
}
